<template>
  <div id="footerNav"></div>
</template>

<script>
export default {
  name: "Footer"
};
</script>

<style scoped>
#footerNav {
  padding: 15px 0;
}

a {
  padding: 0 15px;
  color: #666;
  font-size: 0.7em;
  font-weight: 600;
  text-transform: uppercase;
}
</style>
